export const ZuiBaseMixin = superClass => class extends superClass {
  connectedCallback() {
    super.connectedCallback();
    this.removeAttribute('unresolved');
  }

};